<div class="quote-drop-block">
  <ng-component *ngIf="!blockElement?.isActiveForEdit" [innerHTML]="blockElement?.data"></ng-component>
  <div *ngIf="blockElement?.isActiveForEdit" class="NgxEditor__Wrapper">
    <ngx-editor [editor]="editor" [ngModel]="blockElement.data" (ngModelChange)="onChange($event)" [disabled]="false"
      [placeholder]="'Type here...'"></ngx-editor>
  </div>
</div>